module.exports = __webpack_public_path__ + "img/1-5.150249d4.svg";